import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-member",
  "use": "icon-soc-member-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-member\">\r\n<g transform=\"translate(81.920 -113.571) scale(1.221818)\">\r\n<path d=\"M512 160a160 160 0 1 1 0 320 160 160 0 0 1 0-320zm0 64a96 96 0 1 0 0 192 96 96 0 0 0 0-192z\" />\r\n  <path d=\"M192 800c0-144 144-224 320-224s320 80 320 224v64H192v-64zm96-16c16-80 112-144 224-144s208 64 224 144H288z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-member.svg
// module id = LJOe
// module chunks = 491